import React, {useState, useEffect, useLayoutEffect} from 'react';
import RadioButton from '../../../common/RadioButton';
import '../../../../styles/sd-topn-type-severities.css';

const SuggestedDamagesTopN = (props) => {

    const allTopnTypesSeverities = props.suggestedDamage.topnTypesSeverities;
    const topnTypesSeverities = (props.filteredTopNDamages && props.filteredTopNDamages.length > 0)
        ? props.filteredTopNDamages 
        : allTopnTypesSeverities;
    
    const {suggestedDamage, onSelectionChange} = props;
    const [selectedValue, setSelectedValue] = useState(0);
    
    const radioGroupName = `topnDamages-${suggestedDamage.artCodes?.damageId}`;

    const handleRadioChange = (value) => {
        console.log("Radio button changed to: ", value);
        setSelectedValue(value);
        if (value !== 4) {
            const selectedDamage = {
                ...topnTypesSeverities[value],
                index: topnTypesSeverities[value].originalIndex !== undefined
                    ? topnTypesSeverities[value].originalIndex 
                    : value
            };
            onSelectionChange(selectedDamage, false);
        } else {
            onSelectionChange(null, true);
        }
    }

    useLayoutEffect(() => {
        if (topnTypesSeverities && topnTypesSeverities.length > 0) {
            console.log("Setting initial damage selection to:", topnTypesSeverities[0]);
            setSelectedValue(0);
            const initialDamage = { 
                ...topnTypesSeverities[0], 
                index: topnTypesSeverities[0].originalIndex !== undefined
                    ? topnTypesSeverities[0].originalIndex 
                    : 0
            };
            onSelectionChange(initialDamage, false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.filteredTopNDamages && props.filteredTopNDamages.length > 0) {
            setSelectedValue(0);
            const initialDamage = { 
                ...props.filteredTopNDamages[0], 
                // Use originalIndex if available, otherwise use 0
                index: props.filteredTopNDamages[0].originalIndex !== undefined
                    ? props.filteredTopNDamages[0].originalIndex 
                    : 0
            };
            onSelectionChange(initialDamage, false);
        } 
        else if (props.filteredTopNDamages && props.filteredTopNDamages.length === 0) {
            setSelectedValue(4);
            onSelectionChange(null, true);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.filteredTopNDamages]);
    
    const showOnlyCustom = Array.isArray(props.filteredTopNDamages) && props.filteredTopNDamages.length === 0;

    return (
        <div className="mt-4">
            {!showOnlyCustom && topnTypesSeverities?.slice(0, 3).map((damage, index) => (
                <div key={index} className={`topn-damage-combination ${selectedValue === index ? 'selected' : ''}`}>
                    <RadioButton
                        id={`${radioGroupName}-${index}`}
                        label=""
                        name={radioGroupName}
                        value={index}
                        checked={selectedValue === index}
                        className={selectedValue === index ? "checked-radio" : ""}
                        onChange={() => {handleRadioChange(index)}}
                        />
                        <div className='d-flex flex-grow-1'><span className='flex-grow-1'>{damage.type}</span><span>{damage.severity}</span></div>
                </div>
            ))}
            <div className="custom-topn-damage-combination pb-1">
                <div>
                    <RadioButton
                        id={`${radioGroupName}-4`}
                        label="Custom"
                        name={radioGroupName}
                        value={4}
                        checked={selectedValue === 4} 
                        onChange={() => {handleRadioChange(4)}}
                    />
                </div>
            </div>
        </div>
    );
};

export default SuggestedDamagesTopN;